import { Box, Stack, Typography, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

export interface FilterDisplayChipProps {
  label: string;
}

export const FilterDisplayChip = ({
  label,
  children,
}: PropsWithChildren<FilterDisplayChipProps>) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      columnGap={1}
      alignItems="center"
      sx={{
        borderRadius: 1.5,
        border: `1px solid ${theme.palette.divider}`,
        overflow: 'hidden',
        height: theme.spacing(4),
      }}
    >
      <Box
        sx={{
          height: '100%',
          backgroundColor: theme.palette.action.hover,
          px: 1,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography variant="caption" fontWeight="bold">
          {label}
        </Typography>
      </Box>

      <Box
        sx={{
          pr: 1,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {children}
      </Box>
    </Stack>
  );
};
